export const kejiArticles = [
  {
    id: "keji-1",
    title: "智能门锁安全测试：低端型号竟可被蓝牙破解",
    summary: "在一组公开测试中，部分低价智能门锁的安全性令人担忧。问题出在哪一环？",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-12 11:50",
    source: "硬件实验室",
    tags: ["智能门锁", "安全测试", "物联网"],
    heat: 8260,
    content: [
      "智能门锁走进越来越多的家庭，其安全性也备受关注。一组实验室测试显示，部分低价型号在蓝牙通信环节存在明显漏洞。",
      "## 漏洞出现在哪里",
      "测试人员介绍，问题主要集中在通信加密不足与固件更新机制缺失。一旦被利用，攻击者有可能在近距离内完成解锁尝试。",
      "厂商方面回应称，部分问题可通过固件升级修复，但旧型号是否支持更新仍需确认。",
      "## 智能设备不能只拼价格",
      "安全专家建议，选购智能门锁时应关注加密方案与更新支持，而非仅看价格与外观。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "keji-2",
    title: "共享充电宝涨价背后：成本、亏损与隐形的数据采集",
    summary: "每小时价格一路上涨，共享充电宝的账本究竟怎么算？答案可能不止成本。",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-11 15:05",
    source: "科技消费观察",
    tags: ["共享经济", "充电宝", "隐私"],
    heat: 6790,
    content: [
      "共享充电宝的租借价格近年来被频繁讨论。从最初的每半小时一元，到如今部分场景的每小时数元，涨价的逻辑值得梳理。",
      "## 账本上的成本与亏损",
      "据业内人士介绍，设备的折旧、场地分成与运维成本构成了主要支出，而客流分布不均又加剧了盈利压力。",
      "不过在成本之外，用户授权环节也被提及。部分小程序会请求获取较多权限，引发对数据采集的讨论。",
      "## 便利与边界需平衡",
      "受访专家认为，共享服务在提供便利的同时，应把权限请求控制在必要范围内，并清楚说明用途。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "keji-3",
    title: "二手平台验机报告造假调查：翻新机如何被判定为原装",
    summary: "一份“全绿”的验机报告，可能并不代表机器真的没问题。报告背后的标准值得追问。",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-10 20:30",
    source: "数码求真社",
    tags: ["二手交易", "验机", "翻新机"],
    heat: 7510,
    content: [
      "在二手数码交易中，验机报告常被买家视为重要依据。然而有用户反映，标注为原装的设备，到手后却被发现是翻新机。",
      "## 报告与实物的差距",
      "技术人员比对发现，部分翻新设备在外观与电池数据上被处理过，若仅依赖常规检测项，容易得出“正常”的结论。",
      "有从业者承认，不同平台的验机标准存在差异，报告的可信度也不尽相同。",
      "## 标准化才能建立信任",
      "消费者呼吁，二手平台应公开验机项目与判定标准，并完善售后责任，让报告真正具有参考价值。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "keji-4",
    title: "智能音箱隐私争议：语音数据到底被传到了哪里",
    summary: "唤醒之后，音箱录下了什么？这些数据又流向了何处？我们梳理了公开的说明。",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-09 18:20",
    source: "隐私研究组",
    tags: ["智能家居", "语音数据", "隐私"],
    heat: 6930,
    content: [
      "智能音箱已成为不少家庭的常备设备，围绕语音数据的讨论也随之升温。用户最关心的问题是：设备究竟记录了什么，数据又被用在了哪里。",
      "## 唤醒与上传的机制",
      "根据厂商公开说明，设备通常会在本地先识别唤醒词，再决定是否上传语音片段用于处理。但不同产品在本地处理的比例上差别较大。",
      "有用户担心，误唤醒可能导致无意间的语音被采集。",
      "## 把选择权交还用户",
      "专家建议，厂商应提供清晰的记录查看与删除入口，并默认采用更保守的数据策略。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "keji-5",
    title: "折叠屏良率之困：高返修率背后厂商在隐瞒什么",
    summary: "折叠屏手机的维修数据一直不透明。我们从售后渠道了解到了一些真实情况。",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-08 09:10",
    source: "硬件实验室",
    tags: ["折叠屏", "良率", "售后"],
    heat: 6080,
    content: [
      "折叠屏手机的屏幕与铰链是公认的技术难点，其返修情况也一直是行业关注的焦点。公开数据有限，让消费者难以判断真实可靠性。",
      "## 售后端看到的情况",
      "多位维修从业者透露，早期的折叠屏机型在屏幕折痕与铰链异响方面的返修比例相对偏高，后续机型有所改善。",
      "厂商则更多强调技术迭代，较少披露具体的返修数据。",
      "## 透明数据有助于理性消费",
      "业内人士建议，厂商可适度公开可靠性测试结果，帮助消费者做出更理性的选择。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "keji-6",
    title: "充电桩计量争议：同一辆车为何两处充电电量相差明显",
    summary: "同样的车，不同充电桩上显示的电量并不一致。问题可能出在计量环节。",
    categoryId: "keji",
    categoryName: "科技解密",
    publishedAt: "2026-10-07 17:45",
    source: "新能源观察",
    tags: ["充电桩", "计量", "新能源"],
    heat: 5650,
    content: [
      "随着电动车普及，充电桩成为日常生活的一部分。有车主发现，同一辆车在不同充电桩上充电时，显示的电量存在明显差异。",
      "## 计量差异可能的原因",
      "检测人员介绍，差异可能来自计量模块的精度、线路损耗以及充电过程中的环境温度等多种因素。",
      "若差异超出合理范围，则不排除设备老化或校准不足的可能。",
      "## 让每一度电都清清楚楚",
      "车主呼吁，运营方应定期对充电桩进行检定，并公开相关记录，让充电消费透明可信。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];